// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './form'
import VuePersist from 'vue-persist'
import VeeValidate from 'vee-validate';

Vue.config.productionTip = false

Vue.use(VuePersist)

const validate_config = {
	locale: 'pl',
	events: 'blur'
};

Vue.use(VeeValidate, validate_config);

// zezwalaj na dbtools w skompilowanym
// pokazuje si edevtools w zakladce ale jest puste
Vue.config.devtools = true


/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App }
})


// dodaj do wiki
// odano event blur
// i computed


// guziki orm wieloetap na mobilnej

// info tekstowe ze moze tez podac adres


// WEBPACK FOOTER //
// ./src/main.js